import { render } from "./CodeSnippets.vue?vue&type=template&id=713e2318&scoped=true"
import script from "./CodeSnippets.vue?vue&type=script&lang=js"
export * from "./CodeSnippets.vue?vue&type=script&lang=js"

import "./CodeSnippets.vue?vue&type=style&index=0&id=713e2318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713e2318"]])

export default __exports__